export const termsOfServiceUrl =
  'https://www.asurion.com/store-terms-conditions/';
export const termsOfUseUrl = 'https://www.asurion.com/website-terms-of-use/';
export const privacyPolicyUrl = 'https://www.asurion.com/store-privacy-policy/';
export const doNotSellMyPersonalInfo =
  'https://privacyportal.onetrust.com/webform/c40dfca6-525d-44cd-82a0-f892f87753af/3628ce01-e3f3-4d8f-9da2-bc60dce6fab2';
